jQuery(document).ready(function ($) {
  //top announcement bar
  $(".announcement-slide").slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: true,
        },
      },
    ],
  });

  var localShippingThresholdPrice =
    theme.freeShippingThreshold * Shopify.currency.rate;
  var freeShippingThresholdText = theme.moneyFormatWithCurrency.replace(
    theme.pricePlaceholderRegex,
    Math.round(localShippingThresholdPrice / 100)
  );
  //console.log(localThresholdPrice, 'fff:; ', freeShippingThresholdText);
    if(theme.freeShippingThreshold != 0) {
      //$(".free-shipping-amount").text(freeShippingThresholdText);
      $(".free-shipping-amount").html(freeShippingThresholdText + '<span>+</span>');
    }
  var localProductThresholdPrice =
    theme.freeProductThreshold * Shopify.currency.rate;
  var freeProductThresholdText = theme.moneyFormat.replace(
    theme.pricePlaceholderRegex,
    Math.round(localProductThresholdPrice / 100)
  );
  //console.log(localThresholdPrice, 'fff:; ', freeShippingThresholdText);
  $(".free-product-amount").text(freeProductThresholdText);

  //dyanamic gift amount
    var localGiftAmount =
    theme.giftAmount * Shopify.currency.rate;
  var giftAmountText = theme.moneyFormatWithCurrency.replace(
    theme.pricePlaceholderRegex,
    Math.round(localGiftAmount / 100)
  );
  console.log(Shopify.currency.rate); 
  $(".gift-amount").text(giftAmountText);

  setTimeout(function () {
    $("body").removeAttr("style");
  }, 300);

  $(".banner-new .banner-slider .slick").slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    pauseOnHover: false,
  });

  $(".header-wrapper").addClass("initial-header");
  $(window).on("scroll", function () {
    if ($(this).scrollTop() < 100) {
      $(".header-wrapper").addClass("initial-header");
    } else {
      $(".header-wrapper").removeClass("initial-header");
    }
  });

  //$("html, body").animate({ scrollTop: 0 }, "50");
  var btn = $(".header__menu .menu a"),
    sideMenu = $(".side-menu"),
    pageWrapper = $(".page-wrapper"),
    closeBtn = $(".side-menu__header .close-btn");
  btn.click(function (e) {
    e.preventDefault;
    var btnText = btn.text();
    $(this).toggleClass("open");
    // if( $(this).hasClass('open') ) {
    //   $(this).text('Close');
    // } else {
    //   $(this).text('Menu');
    // }
    pageWrapper.addClass("overflow-hidden").toggleClass("open");
    setTimeout(function () {
      pageWrapper.removeClass("overflow-hidden");
    }, 600);
    sideMenu.toggleClass("open");
    $("body").addClass("open");
  });
  closeBtn.click(function (e) {
    e.preventDefault;
    var menuBtnText = btn.text();
    btn.removeClass("open");
    pageWrapper.addClass("overflow-hidden").toggleClass("open");
    setTimeout(function () {
      pageWrapper.removeClass("overflow-hidden");
    }, 600);
    sideMenu.removeClass("open");
    $("body").removeClass("open");
    $(".menu-dropdown--second-level").slideUp();
    $('.menu-navigation__item--has-dropdown').removeClass('active');
  });

  //scrolling text
  // $(".text-slide").jConveyorTicker({
  //   anim_duration: 200,
  //   reverse_elm: true,
  // });
  // $(".infinite-scroll").on("mouseover", function () {
  //   jsTicker.playAnim();
  // });
  // if (window.matchMedia("(max-width: 768px)").matches) {
  //   var jsTicker = $(".ticker-slide").jConveyorTicker({
  //     anim_duration: 200,
  //     reverse_elm: true,
  //     force_loop: true,
  //   });
  // } else {
  //   var jsTicker = $(".ticker-slide").jConveyorTicker({
  //     anim_duration: 100,
  //     reverse_elm: true,
  //     force_loop: true,
  //   });
  // }

  // Lashes Slider
  $("#shopify-section-product-lashes-template .lashes-slider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 4000,
    variableWidth: true,
    slidesToShow: 4,
    //centerMode: true,
    //centerPadding: '18%',
    slidesToScroll: 1,
    prevArrow: $(".lashes-arrow.prev-arrow"),
    nextArrow: $(".lashes-arrow.next-arrow"),
    fade: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 988,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          arrows: false,
          prevArrow: null,
          nextArrow: null,
        },
      },
    ],
  });

  var lastScrollTop = 0;

  // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
  // window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
  //     if ( $(window).scrollTop() > 200 ) {
  //       var st = window.pageYOffset || document.documentElement.scrollTop;
  //     if (st > lastScrollTop){
  //       setTimeout(function(){
  //         $('.header-wrapper').addClass('header-wrapper--hidden').removeClass('header-wrapper--fixed');
  //       },800)
  //     } else {
  //       setTimeout(function(){
  //         $('.header-wrapper').removeClass('header-wrapper--hidden').addClass('header-wrapper--fixed');
  //       },800)
  //     }
  //     lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  //     }
  //   }, false);

  // slide two column collection

  $(".two-collection-slide .single-model-block__item .title").click(
    function () {
      $(".single-model-block__item.last").toggleClass("push");
      $(".single-model-block__item.last").removeClass("bounce-left");
      $(".single-model-block__item.last").addClass("bounce-added");
      $(this)
        .parents(".full-container")
        .find(".single-model-block__item")
        .removeClass("active");
      $(this).parents(".single-model-block__item").addClass("active");
    }
  );

  // $('.single-model-block__item.last .title').click(function(){
  //   $('html, body').animate({
  //     scrollTop: $(".single-model-block__item.last").offset().top + $(window).height()
  // }, 2000);
  // });
  // $('.single-model-block__item.first .title').click(function(){
  //   $('html, body').animate({
  //     scrollTop: $(".single-model-block__item.first").offset().top - $(window).height()
  // }, 2000);
  // });

  $(".four-collection-slide .single-model-block__item").hover(function () {
    $(this)
      .parents(".full-container")
      .find(".single-model-block__item")
      .removeClass("active");
    $(this).addClass("active");
  });
  $(".four-collection-slide .single-model-block__item").each(function () {
    var _this = $(this);
    var leftvalue = _this.offset().left;
    console.log(leftvalue);
    _this.attr("data-left", leftvalue);
  });
  $(".four-collection-slide .single-model-block__item")
    .mouseover(function () {
      $(this).addClass("active");
      var _this = $(this);
      var leftvalue = _this.data("left") - 25;
      $(".four-collection-slide").animate({ scrollLeft: leftvalue });
    })
    .mouseout(function () {
      $(this).removeClass("active");
    });

  //Customize popup
  $(".customize-popup .set-color").on("click", function () {
    $("body").css("overflow", "hidden");
    $(".loading-wrap").css("display", "flex");
    $(".customize-popup .item.active").removeClass("active");
    $(this).addClass("active");
    var color = $(this).data("color") != "" ? $(this).data("color") : null;
    //console.log(color);
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: { "attributes[Eye color]": color },
      dataType: "json",
      success: function (data) {
        //console.log(data);
        window.location.reload();
      },
    });
  });

  //spantext
  $(".menu-navigation__title")
    .filter(function () {
      return $(this).text().trim() === "Lens quiz";
    })
    .addClass("launchday");

  $(".side-menu .menu-navigation__list-item .menu-navigation__item").addClass(
    "nohover"
  );

  /*$('.clear-selection').on('click', function(){
    $('.customize-popup .item.active').removeClass('active');
    $(this).addClass('active');
    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: { "attributes[Eye color]": null },
      dataType: 'json',
      success: function(data){
        //console.log(data);
        window.location.reload();
      }
    });
  });*/

  // $('.four-collection-slide .single-model-blocks').scrollLeft(200);
  //onload effect
  $(".banner").on("click", function () {
    if ($(this).hasClass("banner-onload")) {
      $(this).removeClass("banner-onload");
      $("html").removeClass("body-load");
    }
  });

  // cart quantity increase decrease
  $(document).on("click", ".add", function () {
    var step = $(this).prev().data("step") ? $(this).prev().data("step") : 1;
    $(this)
      .prev()
      .val(+$(this).prev().val() + step)
      .trigger("change");
  });
  $(document).on("click", ".sub", function () {
    var step = $(this).next().data("step") ? $(this).next().data("step") : 1;
    if ($(this).next().val() > step) {
      $(this)
        .next()
        .val(+$(this).next().val() - step)
        .trigger("change");
    }
  });

  // Trigger the slide-in effect on scroll
  $(window).scroll(function () {
    $(".animation").each(function (i) {
      var bottomWindow = $(window).scrollTop() + $(window).height();
      var Objecttop = $(this).offset().top;
      var bottomObject = $(this).offset().top + $(this).outerHeight() / 2;
      var test = bottomWindow - Objecttop;

      if (bottomWindow > bottomObject) {
        $(this).addClass("animation-visible");

        if ($(this).hasClass("bg-animation")) {
          var x = $(window).scrollTop() - $(this).offset().top / 2;
          console.log(x);
          $(this).css(
            "background-position",
            "center " + parseInt(-x / 1) + "px"
          );
        }
        if ($(this).hasClass("animate-bounce")) {
          if (!$(this).find(".push").hasClass("bounce-added")) {
            $(this).find(".push").addClass("bounce-left");
          }
        }
      }
    });
  });

  // home page banenr sesson
  if (sessionStorage.getItem("bannerOverlay") == "shown") {
    $(".banner").removeClass("banner-onload");
    $("html").removeClass("body-load");
  } else {
    sessionStorage.setItem("bannerOverlay", "shown");
  }

  //
  $("#before-after").twentytwenty({
    before_label: "BEFORE",
    after_label: "AFTER",
    no_overlay: false,
  });
  var _width = $(window).width();
  if (_width < 1025) {
    // $('.slider-wrapper').slick({
    //   arrows:false,
    //   dots:true,
    //   infinite: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   draggable: true,
    //   swipe: true,
    // });
    $(".slider-wrapper").flickity({
      // options
      cellAlign: "left",
      contain: false,
      //fullscreen: false,
      wrapAround: false,
      prevNextButtons: false,
    });
    $(".pink-text").slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      swipe: true,
    });
    setTimeout(() => {
      //$('.slider-wrapper .media-hover').addClass('visible');
    }, 500);
  }
  // Check if the URL has the fragment #opencart
  if (window.location.hash === "#CartOpen") {
    // Trigger the OpenCart event or any action you want
    document.querySelector(".header__icons .header__icon--cart").click();
  }
  //mobilemenu
  $(".menu-navigation__list-item > .menu-navigation__item--has-dropdown").on(
    "click",
    function (e) {
      e.preventDefault();

      var $this = $(this);
      var $dropdown = $this.siblings(".menu-dropdown--second-level");

      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $dropdown.stop(true, true).slideUp(500);
      } else {
        $this.addClass("active");
        $dropdown.stop(true, true).slideDown(500);
      }
    }
  );
  // $(".menu-navigation__list-item > .menu-navigation__item--has-dropdown").on("click", function(e) {
  //   e.preventDefault();
  //   if ($(this).hasClass("active")) {
  //     $(this).removeClass("active");
  //     $(this).siblings(".menu-dropdown--second-level").slideUp(500);
  //   } else {
  //     $(".menu-navigation__list-item > .menu-navigation__item--has-dropdown").removeClass("active");
  //     $(this).addClass("active");
  //     // $(".menu-dropdown--second-level").slideUp(500);
  //     $(this).siblings(".menu-dropdown--second-level").slideDown(500);
  //   }
  // });

  //megamenu
  $(function () {
    var _width = $(window).width();
    if (_width > 1201) {
      $(".has-submenu").hover(function () {
        if (!$(this).hasClass("active")) {
          // $(this).addClass('active');
        }
      });
      $(document).mouseleave(".mega-menu", function () {
        $(this).parent(".menu-link").removeClass("active");
      });
    }
    if (_width > 767 && _width <= 1200) {
      $(".has-submenu > a").click(function (e) {
        e.preventDefault();
        $(this).parent().toggleClass("open");
      });
    }
  });
});

$(window).scroll(function () {
  scroll = $(window).scrollTop();
  if (scroll >= 10) {
    $(".banner").removeClass("banner-onload");
    $("html").removeClass("body-load");
  }
});

$(function () {
  var _width = $(window).width();
  if (_width < 2600) {
    $(".home-product-slider .product-list-wrap").mousewheel(function (
      event,
      delta
    ) {
      this.scrollLeft -= delta * 40;
      console.log(delta);
      var scrollLeftPrev = 0;
      var $elem = $(".product-list-wrap");
      var newScrollLeft = $elem.scrollLeft(),
        width = $elem.width(),
        scrollWidth = $elem.get(0).scrollWidth;
      if (scrollWidth - newScrollLeft - width < 1 || newScrollLeft === 0) {
      } else {
        event.preventDefault();
      }
      scrollLeftPrev = newScrollLeft;
    });
  }
});

// var e = document.querySelector(".product-list-wrap");
// var n = document.querySelector(".progress-bar");
// if (n) {
//     var a = ((e.scrollLeft + e.offsetWidth) / e.scrollWidth) * 100;
//     n.style.width = Math.round(a) + "%";
//     e.addEventListener("scroll", function () {
//         a = ((e.scrollLeft + e.offsetWidth) / e.scrollWidth) * 100;
//         n.style.width = Math.round(a) + "%";
//     });
// }

// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
// var selecter = $('.single-model-block__item.last');
// gsap.to('.single-model-block__item.last', {
//   scrollTrigger: {
//     trigger: '.two-collection-slide',
//     toggleActions: "restart pause resume reset",
//     toggleClass: 'active',
//     start: 'top top',
//     pin:true,
//     scrub: 1,
//     // markers:true,
//   },
//   x: 0,
//   duration: 5,
// });

var ee = document.querySelector(".product-list-wrap");
var n = document.querySelector(".progress-bar");
if (n) {
  var bar = ((ee.scrollLeft + ee.offsetWidth) / ee.scrollWidth) * 100;
  ee.addEventListener("scroll", function () {
    a = (ee.scrollLeft / ee.scrollWidth) * 100;
    n.style.left = Math.round(a) + "%";
  });
  n.style.width = Math.round(bar) + "%";
}
